import { getRequest } from './authHttpClient';
import { config } from '../utils/apiConfig';

const resourceUrl = `${config.API_URL}/leaderboard`;

export const getLeaderBoard = async () => {
  const result = await getRequest(resourceUrl);
  return result.data;
};
